// extracted by mini-css-extract-plugin
export default {"links":"_986fa8ba","link":"_48a59cc9","wrapper":"_e45f1d5a","header":"_3ebc5db6","innerWrapper":"_8f329284","item":"_71bae1fc","noUnderline":"_fb2b90ce","itemContainer":"_ddb9969b"};